const ParaguaySvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112141)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9998 0C12.0706 0 5.21938 4.61445 1.98438 11.3044H38.0152C34.7803 4.61445 27.929 0 19.9998 0Z"
        fill="#D80027"
      />
      <path
        d="M19.9998 39.9997C27.929 39.9997 34.7803 35.3852 38.0153 28.6953H1.98438C5.21938 35.3852 12.0706 39.9997 19.9998 39.9997Z"
        fill="#0052B4"
      />
      <path
        d="M24.9188 14.2119L23.0742 16.0565C23.861 16.8433 24.3478 17.9303 24.3478 19.1309C24.3478 21.5321 22.4011 23.4787 19.9999 23.4787C17.5988 23.4787 15.6521 21.5321 15.6521 19.1309C15.6521 17.9303 16.1388 16.8433 16.9256 16.0565L15.081 14.2119C13.8221 15.4707 13.0435 17.2098 13.0435 19.1309C13.0435 22.9729 16.158 26.0874 19.9999 26.0874C23.8419 26.0874 26.9564 22.9729 26.9564 19.1309C26.9563 17.2098 26.1778 15.4707 24.9188 14.2119Z"
        fill="#6DA544"
      />
      <path
        d="M19.9998 16.5215L20.6474 18.5145H22.7428L21.0475 19.746L21.6951 21.7389L19.9998 20.5073L18.3045 21.7389L18.9521 19.746L17.2568 18.5145H19.3522L19.9998 16.5215Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112141">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default ParaguaySvg;
